import styled from 'styled-components';

export const ProductInfoStyled = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: center;

    > div {
        display: flex;
        gap: 16px;
        align-items: center;
        justify-content: center;

        > div {
            display: flex;
            gap: 8px;
            align-items: center;
        }
    }
`;
